/**
 * Универсальные «подвкладки» внутри одного раздела бокового меню.
 *
 * Используется там, где несколько прежде самостоятельных разделов были
 * объединены в один пункт бокового меню (например, «Выделение» = старые
 * разделы «Выделение и примечания» + «Свойства выделения»; «Поиск и
 * фильтры» = «Фильтрация» + «Поиск»; «Визуализация» = «Разрезы» + «Виды» +
 * «Цветовые правила»). Функциональность самих инструментов не меняется —
 * меняется только группировка в UI.
 *
 * Разметка:
 *   <div class="subtabs">
 *     <button class="subtab-btn is-active" data-subtab-target="a">…</button>
 *     <button class="subtab-btn" data-subtab-target="b">…</button>
 *   </div>
 *   <div class="subtab-panel is-active" data-subtab-panel="a">…</div>
 *   <div class="subtab-panel" data-subtab-panel="b">…</div>
 *
 * Это чисто клавиатурно/мышино/тач-независимые кнопки (обычный `click`),
 * поэтому работает одинаково на десктопе и на мобильных без дополнительной
 * обвязки под touch-события.
 */

function activateSubtab(bar: HTMLElement, target: string): void {
  const host = bar.parentElement;
  if (!host) {
    return;
  }
  bar.querySelectorAll<HTMLButtonElement>(".subtab-btn").forEach((btn) => {
    const active = btn.dataset.subtabTarget === target;
    btn.classList.toggle("is-active", active);
    btn.setAttribute("aria-selected", String(active));
  });
  host.querySelectorAll<HTMLElement>(":scope > .subtab-panel").forEach((panel) => {
    panel.classList.toggle("is-active", panel.dataset.subtabPanel === target);
  });
}

export function initSubtabs(): void {
  document.querySelectorAll<HTMLElement>(".subtabs").forEach((bar) => {
    bar.querySelectorAll<HTMLButtonElement>(".subtab-btn").forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = btn.dataset.subtabTarget;
        if (!target) {
          return;
        }
        activateSubtab(bar, target);
      });
    });
  });
}
